import {
    CREATE_LCAPAF_STARTED, CREATE_LCAPAF_COMPLETED, CREATE_LCAPAF_FAILED,
    UPDATE_LCAPAF_STARTED, UPDATE_LCAPAF_COMPLETED, UPDATE_LCAPAF_FAILED,
    GET_LCAPAFBYID_STARTED, GET_LCAPAFBYID_SUCCESS, GET_LCAPAFBYID_FAILED,
    GET_LCAPAFBYCHILDCASEID_STARTED, GET_LCAPAFBYCHILDCASEID_SUCCESS, GET_LCAPAFBYCHILDCASEID_FAILED,
    GET_LCAPAFBYLISTCASEID_STARTED, GET_LCAPAFBYLISTCASEID_SUCCESS, GET_LCAPAFBYLISTCASEID_FAILED,
    GET_LCAPAFBYCOMPANYID_STARTED, GET_LCAPAFBYCOMPANYID_SUCCESS, GET_LCAPAFBYCOMPANYID_FAILED,
    GETALL_LCAPAF_STARTED, GETALL_LCAPAF_SUCCESS, GETALL_LCAPAF_FAILED
} from '../actions/VisacareLCAPAFData';

const intialData = {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {
        insert_datetime: "",
        inserted_by: "",
        update_datetime: "",
        updated_by: ""

    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};


export const visaCareLCAPAFData = (state = intialData, action: any) => {

    switch (action.type) {
        case CREATE_LCAPAF_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case CREATE_LCAPAF_COMPLETED:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case CREATE_LCAPAF_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        case UPDATE_LCAPAF_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case UPDATE_LCAPAF_COMPLETED:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case UPDATE_LCAPAF_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        case GET_LCAPAFBYID_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case GET_LCAPAFBYID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case GET_LCAPAFBYID_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        case GET_LCAPAFBYCHILDCASEID_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case GET_LCAPAFBYCHILDCASEID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case GET_LCAPAFBYCHILDCASEID_FAILED:
            return {
                ...state,
                isLoading: true,
            };       
        case GET_LCAPAFBYCOMPANYID_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case GET_LCAPAFBYCOMPANYID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case GET_LCAPAFBYCOMPANYID_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        case GETALL_LCAPAF_STARTED:
            return {
                ...state,
                items: [],
                isLoading: true,
            };
        case GETALL_LCAPAF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                status: action.status,
                items: action.payload
            };
        case GETALL_LCAPAF_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        default:
            return state;
    }

}


export const visaCareLCAPAFDataList = (state = intialData, action: any) => {
    switch (action.type) {
    case GET_LCAPAFBYLISTCASEID_STARTED:
        return {
            ...state,
            items: [],
            isLoading: true,
        };
    case GET_LCAPAFBYLISTCASEID_SUCCESS:
        return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
        };
    case GET_LCAPAFBYLISTCASEID_FAILED:
        return {
            ...state,
            isLoading: true,
        };
        default:
            return state;
    }
}